import type { PluginOptions } from './type';
import { useSettingsStore, useDocumentStore } from '../stores';

const options: PluginOptions = {
  onVuePluginRegister: async () => {
    const { settings } = useSettingsStore();
    const { setDocumentTitle } = useDocumentStore()
    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
    setDocumentTitle()
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = settings.system.faviconIco || settings.system.logo || '/favicon.ico';
  },
};

export default options;
